import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-width: 300px;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const Title = styled.h2`
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
`;

export const FieldBlock = styled.div`
  margin-bottom: 12px;
  width: 100%;
`;

export const FieldLabel = styled.h4`
  margin: 0 0 4px 0;
  font-weight: bold;
`;

export const FieldValue = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`;

export const MetadataBox = styled.pre`
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 12px;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
`;